import { BookingVehicleInfo } from "@/components/booking/BookingVehicleInfo";
import { BrandBottomSheetModal } from "@/components/bottom-sheet-modal";
import { ThemedText } from "@/components/themed-text";
import { formatVehicleLabel } from "@/components/vehicle/vehicle-card-utils";
import { BrandColors } from "@/constants/theme";
import { useAuth } from "@/contexts/auth-context";
import { Booking } from "@/lib/services/bookings";
import { BottomSheetModal } from "@gorhom/bottom-sheet";
import Ionicons from "@react-native-vector-icons/ionicons";
import React, { useRef } from "react";
import { StyleSheet, TouchableOpacity, View } from "react-native";

const canShowVehicleDetails = (booking: Booking) => {
  return (
    booking.status !== "pending" &&
    booking.status !== "quoted" &&
    booking.status !== "cancelled"
  );
};

interface BookingVehicleDetailsLinkProps {
  booking: Booking;
}

export function BookingVehicleDetailsLink({
  booking,
}: BookingVehicleDetailsLinkProps) {
  const { theme } = useAuth();
  const vehicleDetailsSheetRef = useRef<BottomSheetModal>(null);

  const subtitle =
    [booking.vehicle_make, booking.vehicle_model]
      .filter(Boolean)
      .map(formatVehicleLabel)
      .join(" ") ||
    booking.vehicle_registration ||
    "Registration and vehicle info";

  if (!canShowVehicleDetails(booking)) {
    return null;
  }

  return (
    <>
      <TouchableOpacity
        style={[
          styles.vehicleDetailsLink,
          {
            backgroundColor: theme.card,
            borderColor: theme.border,
          },
        ]}
        onPress={() => vehicleDetailsSheetRef.current?.present()}
        activeOpacity={0.7}
      >
        <View style={styles.vehicleDetailsIcon}>
          <Ionicons name="car-outline" size={20} color={BrandColors.primary} />
        </View>
        <View style={styles.vehicleDetailsText}>
          <ThemedText type="smallSemiBold">View vehicle details</ThemedText>
          <ThemedText style={styles.vehicleDetailsSubtitle} type="extraSmall">
            {subtitle}
          </ThemedText>
        </View>
        <Ionicons
          name="chevron-forward"
          size={20}
          color={BrandColors.mediumGray}
        />
      </TouchableOpacity>

      <BrandBottomSheetModal
        ref={vehicleDetailsSheetRef}
        title="Vehicle details"
        snapPoints={["60%", "85%"]}
        onSelect={() => {}}
        onClose={() => vehicleDetailsSheetRef.current?.dismiss()}
      >
        <BookingVehicleInfo booking={booking} embedded />
      </BrandBottomSheetModal>
    </>
  );
}

const styles = StyleSheet.create({
  vehicleDetailsLink: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
    borderRadius: 16,
    borderWidth: 1,
    padding: 14,
    marginVertical: 12,
  },
  vehicleDetailsIcon: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: BrandColors.backgroundGray,
    alignItems: "center",
    justifyContent: "center",
  },
  vehicleDetailsText: {
    flex: 1,
    gap: 2,
  },
  vehicleDetailsSubtitle: {
    color: BrandColors.mediumGray,
    textTransform: "capitalize",
  },
});
